import { Link, Modal, TableCell, Text } from '@amzn/meridian';
import { isEmpty } from 'es-toolkit/compat';
import type { PlacementTableContentValues } from 'features/traffic/campaigns/campaign-configs/types';
import { LabelCell } from 'features/traffic/campaigns/TPCampaignSummary/components/LabelCell';
import { useCallback, useState } from 'react';

const KeywordsSummaryTableRow = ({
  flavorName,
  placementTableData,
}: {
  flavorName: string;
  placementTableData: Record<string, PlacementTableContentValues>;
}) => {
  const { keywords } = placementTableData;
  const [open, setOpen] = useState(false);
  const onClickButton = useCallback(() => setOpen(true), []);
  const onClose = useCallback(() => setOpen(false), []);
  if (isEmpty(keywords.value)) return null;
  return (
    <>
      <LabelCell label={keywords.label} />
      <TableCell data-cy={`${flavorName}-keywords`}>
        <Link onClick={onClickButton}>View full keywords list</Link>
      </TableCell>
      <Modal
        aria-describedby="modal-description"
        closeLabel="Close"
        onClose={onClose}
        open={open}
        scrollContainer="modal"
        title="Keyword List"
        width={625}
      >
        <div
          style={{
            whiteSpace: 'pre-wrap',
          }}
        >
          <Text>{Array.isArray(keywords.value) ? keywords.value.join('\n') : ''}</Text>
        </div>
      </Modal>
    </>
  );
};

export { KeywordsSummaryTableRow };
